/**
 * 创建人：袁俊双
 * 时间：2019-12-27
 * 描述：在业务中点击修改流程和删除流程时弹出此模态框
 * 使用说明: 
 * 动态创建确认框, type 可以是 'edit' 或者 'delete'
 * this.create.createModal(SwEditdeleteWorkflowComponent,{type:"edit",keyWord:"xxx"},this.continue.bind(this))
 * 更新记录: 
 */
import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { SwModalframeComponent } from '../../basic-components/sw-modal-frame/sw-modal-frame.component';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sw-editdelete-workflow',
  templateUrl: './sw-editdelete-workflow.component.html',
  styleUrls: ['./sw-editdelete-workflow.component.css']
})
export class SwEditdeleteWorkflowComponent implements OnInit {
  /**
   * 动态创建的参数 {type:"edit",keyWord:"xxx"}
   * @ignore
   */
  @Input() param 

  /**
   * 动态创建的抛出
   * @ignore
   */
  @Output() callback = new EventEmitter()  

  /**
   * 修改流程--edit,此时有默认的title和headerLogo , 删除流程--delete,此时有默认的title和headerLogo, 其他--null,当类型为其他的时候,title和headerLogo一定要输入,
   * @ignore
   */
  @Input() type:string;

  /**
   * 模态框内容标题
   * @ignore
   */
  @Input() title:string

  /**
   * 模态框标题
   * @ignore
   */
  @Input() headerLogo:string

  /**
   * 流程关键字
   * @ignore
   */
  @Input() keyWord: string

  /**
   * 流程图地址
   * @ignore
   */
  pngUrl:string 

  /**
   * 申请修改或删除的原因
   * @ignore
   */
  reason:string 

  /**
   * 模态框
   * @ignore
   */
  @ViewChild("processConfirmModal") processConfirmModal: SwModalframeComponent;

  constructor(
    
    private systemId:SystemIdService,
    
  ) { }

  ngOnInit() {
    let sId = this.systemId.getSystemId()
    if(this.param){
      this.type = this.param.type
      this.keyWord = this.param.keyWord
      this.headerLogo = this.param.headerLogo
      this.title = this.param.title
    }
    //根据传入的keyWord来拼接流程图请求接口
    this.pngUrl = `${environment.activitiWebAPI}activitiModel/getProcessPng?systemId=${sId}&key=${this.keyWord}&version=-1`
    if(this.type == 'edit'){
      //如果是修改流程
      this.headerLogo = this.headerLogo || '修改申请提示'
      this.title = this.title || "确认发起修改申请吗？"
    } else if(this.type == 'delete'){
      //如果是删除流程
      this.headerLogo = this.headerLogo || '删除申请提示'
      this.title = this.title || "确认发起删除申请吗？"
    }
    setTimeout(() => {
      this.processConfirmModal.toggle()  //打开模态框
    }, 200);
  }


  //点击取消
  cancel(){
    //关闭模态框,销毁组件, 不调用回调函数
    this.processConfirmModal.toggle()
    this.callback.emit(false)
  }

  //点击确认按钮
  sure(){
    //关闭模态框,销毁组件, 调用回调函数
    this.processConfirmModal.toggle()
    if(this.reason){
      this.callback.emit({reason:this.reason})
    } else {
      this.callback.emit({reason:''})
    }
  }


}
